import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import NavbarForOnboardingForm from "./onboarding/NavbarForOnbardingForm";
import { useLoading } from "./LoadingContext";

const CandidateQualificationForm = () => {
  const navigate = useNavigate();
  const { candidate_id } = useParams();
  const [jobRequirements, setJobRequirements] = useState({});
  const [candidateResponse, setCandidateResponse] = useState({});
  const { loading, setLoading } = useLoading();
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCandidateData = async () => {
      setLoading(true);
      try {
        const candidateResponse = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/candidate/candidates/${candidate_id}/`
        );
        const candidateData = candidateResponse.data.data;

        // console.log("Candidate Data:", candidateData);

        const jobDescriptionId = candidateData.job_description;
        if (jobDescriptionId) {
          const jobRequirementsResponse = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/job-descriptions/${jobDescriptionId}/`
          );
          setJobRequirements(jobRequirementsResponse.data);
        } else {
          console.error("Job description ID is missing.");
        }

        setLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError(err);
        setLoading(false);
      }
    };

    fetchCandidateData();
  }, [candidate_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCandidateResponse((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}/candidate/candidates/${candidate_id}/`,
        {
          candidate_id,
          ...candidateResponse,
        }
      );
      console.log("Form submitted successfully:", response.data);
      alert("Your response has been submitted successfully!");

      navigate("/success");
    } catch (err) {
      console.error("Error submitting form:", err);
      alert("There was an error submitting your response. Please try again.");
    }
  };

  if (loading) {
    return (
      <div
        className="container d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div>
          <div
            className="spinner-border text-dark"
            role="status"
            style={{ width: "3rem", height: "3rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <h3 className="text-center text-dark">&nbsp;Data is Fetching.... </h3>
      </div>
    );
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
      <NavbarForOnboardingForm />
      <div className="container py-3">
        <div className="p- rounded">
          <h3 className="text-center text-dark mb-4 font_header">
            Candidate Qualification Form
          </h3>
          <div className="table-responsive table-form text-center">
            <form onSubmit={handleSubmit} className="border border-dark">
              <table
                className="table table-hover"
                style={{
                  tableLayout: "fixed",
                  width: "100%",
                  minWidth: "800px",
                }}
              >
                <thead>
                  <tr className="table-secondary text-center">
                    <th>Information Sought</th>
                    <th>Job Requirement</th>
                    <th>Candidate Response</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Dynamic Fields from Job Requirements */}
                  {[
                    { key: "role", label: "Role" },
                    { key: "total_experience", label: "Total Experience" },
                    {
                      key: "relevant_experience",
                      label: "Relevant Experience",
                    },
                    {
                      key: "mandatory_skills",
                      label:
                        "Mandatory Skills & Experience (e.g., Java(4), C(3))",
                    },
                    { key: "optional_skills", label: "Optional Skills" },
                    { key: "education", label: "Education" },
                    { key: "location", label: "Location" },
                  ].map(({ key, label }) => (
                    <tr key={key} className="text-center">
                      <td>{label}</td>
                      <td>{jobRequirements[key] || "-"}</td>
                      <td>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          name={key}
                          value={candidateResponse[key] || ""}
                          onChange={handleChange}
                          disabled={key === "role"} // Disable input for specific fields
                          required
                        />
                      </td>
                    </tr>
                  ))}

                  {[
                    { key: "current_location", label: "Current Location" },
                    {
                      key: "current_organization",
                      label: "Current Organization",
                    },
                    { key: "certification", label: "Certification" },
                    { key: "availability", label: "Availability" },
                    { key: "notice_period", label: "Notice Period" },
                    {
                      key: "language_proficiency",
                      label: "Language Proficiency",
                    },
                    { key: "ctc", label: "Current CTC" },
                    { key: "ectc", label: "Expected CTC" },
                    {
                      key: "no_of_projects_done_using_mandatory_skill",
                      label: "Number of Projects Done Using Mandatory Skills",
                    },
                    {
                      key: "write_about_yourself",
                      label: "Write About Yourself",
                      type: "textarea",
                    },
                  ].map(({ key, label, type }) => (
                    <tr key={key} className="text-center">
                      <td>{label}</td>
                      <td>-</td>
                      <td>
                        {type === "textarea" ? (
                          <textarea
                            className="form-control border-dark text-dark"
                            name={key}
                            value={candidateResponse[key] || ""}
                            onChange={handleChange}
                            rows={3}
                            required
                          />
                        ) : (
                          <input
                            type="text"
                            className="form-control border-dark text-dark"
                            name={key}
                            value={candidateResponse[key] || ""}
                            onChange={handleChange}
                            required
                          />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="text-center mt-4">
                <button
                  type="submit"
                  className="btn btn-outline-info mb-2 px-5"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CandidateQualificationForm;
